import clsx from "clsx";
import { type FC } from "react";

interface OnOffSwitchProps {
  checked: boolean;
  label: string;
  disabled?: boolean;
  title?: string;
  onChange: (checked: boolean) => void;
}

/** Compact controlled switch for package / rule on-off toggles. */
export const OnOffSwitch: FC<OnOffSwitchProps> = ({ checked, label, disabled, title, onChange }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    title={title}
    disabled={disabled}
    onClick={() => onChange(!checked)}
    className={clsx(
      "relative inline-flex h-5 w-9 flex-shrink-0 items-center rounded-full transition-colors",
      checked ? "bg-globemallow-600" : "bg-bg-disabled",
      disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
    )}
  >
    {/* No surface token for the knob; white matches Mosaic's own toggle. */}
    <span
      className={clsx(
        "inline-block h-4 w-4 rounded-full bg-white shadow transition-transform",
        checked ? "translate-x-4" : "translate-x-0.5",
      )}
    />
  </button>
);
